import { useState } from 'react';
import { Box, Modal, Typography, TextField, Button } from '@mui/material';

export default function TrackingModal({ open, action, onClose, onConfirm }) {
  const [outgoingUSPS, setOutgoingUSPS] = useState('');
  const [returnUSPS, setReturnUSPS] = useState('');
  const [imprintUSPS, setImprintUSPS] = useState('');

  const handleSubmit = () => {
    let trackings = {};
    if (action === 'kitMailed') {
      trackings = { outgoingUSPS, returnUSPS };
    } else if (action === 'imprintMailed') {
      trackings = { imprintUSPS };
    }
    onConfirm(trackings);
    setOutgoingUSPS('');
    setReturnUSPS('');
    setImprintUSPS('');
  };

  return (
    <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="tracking-modal-title"
      >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          border: 'none', // Remove any border
          outline: 'none', // Remove focus outline
        }}
      >
        <Typography id="tracking-modal-title" variant="h6" component="h2" gutterBottom>
          {action === 'kitMailed' ? 'Enter Kit Tracking Numbers' : 'Enter Imprint Tracking Number'}
        </Typography>
        <Typography id="tracking-modal-inputs" sx={{ mb: 3 }}>
          {action === 'kitMailed' && (
            <>
              <TextField
                label="Outgoing Kit Tracking Number"
                value={outgoingUSPS}
                onChange={(e) => setOutgoingUSPS(e.target.value)}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Return Kit Tracking Number"
                value={returnUSPS}
                onChange={(e) => setReturnUSPS(e.target.value)}
                fullWidth
                margin="normal"
              />
            </>
          )}
          {action === 'imprintMailed' && (
            <TextField
              label="Imprint Remedy Tracking Number"
              value={imprintUSPS}
              onChange={(e) => setImprintUSPS(e.target.value)}
              fullWidth
              margin="normal"
            />
          )}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}